import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BulkGrantDetailDownloadResponse } from '@/repositories/generated';

const response: BulkGrantDetailDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['行番号', 'ユーザID', '外部ユーザID', 'エラーメッセージ'],
    ['1', '1', '1', 'エラーメッセージ1'],
  ]),
};

export const bulkGrantErrorDownload = http.get(
  createMockEndpoint('/bulk_grant/:id/download/error'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
